export const ScheduledTaskColumns = [
  // 'id',
  'ClientId',
  'Schedule',
  'TimeZone',
  'Enabled',
  'createdAt',
  // 'updatedAt',
  'TaskId',
  'TaskName',
  'NextInvocation',
];
